var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.968 17.048C20.8693 19.096 22.32 21.9973 22.32 25.752C22.32 28.9093 21.296 31.512 19.248 33.56C17.2 35.608 14.5973 36.632 11.44 36.632C8.368 36.632 5.76533 35.6933 3.632 33.816C1.584 31.8533 0.56 29.1653 0.56 25.752C0.56 23.192 1.54133 20.2907 3.504 17.048L13.744 0.0239944H24.624L17.968 17.048ZM42.032 17.048C44.9333 19.096 46.384 21.9973 46.384 25.752C46.384 28.9093 45.36 31.512 43.312 33.56C41.264 35.608 38.6613 36.632 35.504 36.632C32.432 36.632 29.8293 35.6933 27.696 33.816C25.648 31.8533 24.624 29.1653 24.624 25.752C24.624 23.192 25.6053 20.2907 27.568 17.048L37.808 0.0239944H48.688L42.032 17.048Z",
    fill: "#533C23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/quotation.42e1b038a32edbd599d8fba484d687c4.svg";
export { ForwardRef as ReactComponent };